import { useEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef(callback);
  const hasRun = useRef(false);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Always run once on mount, regardless of delay
  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      savedCallback.current();
    }
  }, []);

  useEffect(() => {
    if (delay === null) return;

    // Run immediately when delay becomes non-null (market opens)
    savedCallback.current();

    const id = setInterval(() => savedCallback.current(), delay);
    return () => clearInterval(id);
  }, [delay]);
}
